var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 60 34",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#______src_modules_lobby_svg_NewTab_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF4F4F",
    d: "M3 7a4 4 0 0 1 4-4h44a4 4 0 0 1 4 4v19a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.136 22h-3.344l-4.304-8.64h-.064l.064 1.632q.032.4.048.816l.032.816V22h-2.304V10.576h3.328l4.288 8.56h.048a19 19 0 0 0-.064-1.568l-.032-.784q-.016-.4-.016-.8v-5.408h2.32zm8.806 0H24.67V10.576h6.272v1.984h-3.68v2.512h3.424v1.984h-3.424V20h3.68zm15.784-11.424L44.022 22h-3.008l-1.264-6-.096-.528-.144-.768a41 41 0 0 0-.128-.784 23 23 0 0 0-.08-.592q-.015.208-.08.592-.064.368-.144.784-.064.4-.128.768-.064.352-.112.544L37.574 22h-3.008l-2.704-11.424h2.528l1.264 6.24q.048.271.128.672.08.384.16.816.08.416.144.816.065.4.096.688.048-.304.112-.688.08-.4.144-.816.08-.416.144-.768l.128-.592 1.392-6.368h2.4l1.36 6.4q.048.208.112.576.08.352.16.768t.144.816l.112.672q.048-.4.144-.944.096-.56.208-1.12.113-.56.192-.928l1.264-6.24z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "______src_modules_lobby_svg_NewTab_svg__a",
    width: 60,
    height: 35,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2463_85011"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2463_85011",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTab);
export default __webpack_public_path__ + "static/media/NewTab.96649abb95e50a16e513aa92309a0db9.svg";
export { ForwardRef as ReactComponent };